import { z } from 'zod'

export const updateManualTotalSchema = z
  .object({
    balance: z.number().optional(),
    date: z
      .string()
      .datetime({ offset: true })
      .refine((v) => new Date(v).getTime() <= Date.now(), 'date cannot be in the future')
      .optional(),
  })
  .refine((v) => v.balance !== undefined || v.date !== undefined, {
    message: 'at least one of balance or date must be provided',
  })

export type UpdateManualTotalDto = z.infer<typeof updateManualTotalSchema>
